module.exports = __webpack_public_path__ + "fonts/d6e6abc9b086eb44038d8d79689ea396.svg";